import requestRequisicaoSegura from './requestRequisicaoSegura';
import { descriptografarDados, criptografarDados } from './seguranca';

export default async function requisicaoSegura({
  endpoint,
  dataForm,
}: {
  endpoint: string;
  dataForm: object;
}) {
  const dataFormRequisicaoSegura = criptografarDados(
    JSON.stringify({
      dataEncriptada: {
        dataForm,
        endpoint,
      },
    }),
  );

  const respostaRequisicaoSegura = await requestRequisicaoSegura(
    dataFormRequisicaoSegura,
  );

  const dadosRequisicaoSegura = await respostaRequisicaoSegura.json();

  const retornoDadosDecriptografados = descriptografarDados(
    dadosRequisicaoSegura?.data?.dadosCriptografados,
  );

  return retornoDadosDecriptografados;
}
